import { render } from "./CardWebinar.vue?vue&type=template&id=96bbaf44"
import script from "./CardWebinar.vue?vue&type=script&lang=ts"
export * from "./CardWebinar.vue?vue&type=script&lang=ts"
script.render = render

export default script